import type { ApiResponse } from "@/types";

import { BaseApi } from "../base.api";

export interface PlatformSettings {
  /** Platforma ulushi foizning yuzdan bir qismida: 2000 = 20%. */
  commissionBps: number;
  updatedAt: string;
  updatedBy: { id: number; firstName: string; lastName: string } | null;
}

/** Talaba xavf chegaralari (hammasi butun son). */
export interface StudentRiskRules {
  attendanceBelow: number;
  minExpectedSessions: number;
  minGradedSessions: number;
  minGradedTasks: number;
  overdueTasks: number;
  inactiveDays: number;
  stalledDays: number;
}

/** O'qituvchi xavf chegaralaridan sozlanadiganlari. */
export interface TeacherRiskRulesSettings {
  missedSessions: number;
  ungradedSessions: number;
  overdueReviews: number;
  slowGradingHours: number;
  minGradedForSpeed: number;
  unansweredQuestions: number;
  studentsAtRiskPercent: number;
  minStudentsAtRisk: number;
}

export interface RiskRulesSettings {
  student: StudentRiskRules;
  teacher: TeacherRiskRulesSettings;
  studentDefaults: StudentRiskRules;
  teacherDefaults: TeacherRiskRulesSettings;
  updatedAt: string;
  updatedBy: { id: number; firstName: string; lastName: string } | null;
}

export interface UpdateRiskRules {
  student?: Partial<StudentRiskRules>;
  teacher?: Partial<TeacherRiskRulesSettings>;
}

/** Kartaga to'lov: pul qabul qilinadigan karta (faqat admin ko'radi). */
export interface CardPaymentSettings {
  enabled: boolean;
  cardNumber: string | null;
  cardHolder: string | null;
  updatedAt: string;
  updatedBy: { id: number; firstName: string; lastName: string } | null;
}

export interface UpdateCardPaymentSettings {
  enabled?: boolean;
  cardNumber?: string;
  cardHolder?: string;
}

/** Platforma sozlamalari — backend'dagi `SettingsController`. */
export class SettingsApi extends BaseApi {
  private readonly baseUrl: string = "/settings/platform";

  /** O'qish moderatorga ham ochiq; o'zgartirish — faqat admin. */
  platform() {
    return this.request.get<PlatformSettings, ApiResponse<PlatformSettings>>(this.baseUrl);
  }

  /** Yangi ulush faqat KEYINGI to'lovlarga ta'sir qiladi — eskilari muzlatilgan. */
  updatePlatform(dto: { commissionBps: number }) {
    return this.request.patch<PlatformSettings, ApiResponse<PlatformSettings>>(this.baseUrl, dto);
  }

  /** Xavf chegaralari: o'qish moderatorga ham, o'zgartirish — faqat admin. */
  riskRules() {
    return this.request.get<RiskRulesSettings, ApiResponse<RiskRulesSettings>>(
      "/settings/risk-rules",
    );
  }

  /** Kartaga to'lov sozlamasi — faqat admin. */
  cardPayments() {
    return this.request.get<CardPaymentSettings, ApiResponse<CardPaymentSettings>>(
      "/settings/card-payments",
    );
  }

  /** Rekvizitsiz yoqib bo'lmaydi (`CARD_SETTINGS_INCOMPLETE`). */
  updateCardPayments(dto: UpdateCardPaymentSettings) {
    return this.request.patch<CardPaymentSettings, ApiResponse<CardPaymentSettings>>(
      "/settings/card-payments",
      dto,
    );
  }

  /** Faqat berilgan maydonlar o'zgaradi; hamma hisobot darhol yangi chegaradan o'qiydi. */
  updateRiskRules(dto: UpdateRiskRules) {
    return this.request.patch<RiskRulesSettings, ApiResponse<RiskRulesSettings>>(
      "/settings/risk-rules",
      dto,
    );
  }
}

export const settingsApi = new SettingsApi();
